(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('formService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    var fac = {
                        getFormTemplates: getFormTemplates,
                        getForm: getForm,
                        sendForm: sendForm,
                        getForms: getForms,
                        createForm: createForm,
                        updateForm: updateForm,
                        deleteForm: deleteForm,
                    };

                    return fac;

                    /**
                     * GET "/apispaces/{apiSpaceId}/forms/templates"
                     * @param {string} apiSpaceId - the api space Id
                     */
                    function getFormTemplates(apiSpaceId) {

                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/forms/templates")
                            .then(getFormTemplatesComplete)
                            .catch(getFormTemplatesFailed);

                        function getFormTemplatesComplete(response) {
                            return response.data;
                        }

                        function getFormTemplatesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{apiSpaceId}/forms/templates"
                     * @param {string} apiSpaceId - the api space Id
                     * @param {string} formId - the form Id
                     */
                    function getForm(apiSpaceId, formId) {

                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/forms/" + formId)
                            .then(getFormComplete)
                            .catch(getFormFailed);

                        function getFormComplete(response) {
                            return response.data;
                        }

                        function getFormFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                   * POST "/apispaces/{apiSpaceId}/forms"
                   * @param {string} apiSpaceId - the api space Id
                   */
                    function createForm(apiSpaceId, data) {

                        return $http.post(urlBase + "/apispaces/" + apiSpaceId + "/forms", data)
                            .then(createFormComplete)
                            .catch(createFormFailed);

                        function createFormComplete(response) {
                            return response.data;
                        }

                        function createFormFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                   * PUT "/apispaces/{apiSpaceId}/forms"
                   * @param {string} apiSpaceId - the api space Id
                   * @param {string} formId - the form Id
                   */
                    function updateForm(apiSpaceId, formId, data) {

                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/forms/" + formId, data)
                            .then(updateFormComplete)
                            .catch(updateFormFailed);

                        function updateFormComplete(response) {
                            return response.data;
                        }

                        function updateFormFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * DELETE "/apispaces/{apiSpaceId}/forms/{formId}"
                     * @param {string} apiSpaceId - the api space Id
                     * @param {string} formId - the form Id
                     */
                    function deleteForm(apiSpaceId, formId) {

                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/forms/" + formId)
                            .then(deleteFormComplete)
                            .catch(deleteFormFailed);

                        function deleteFormComplete(response) {
                            return response.data;
                        }

                        function deleteFormFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }


                    /**
                    * GET "/apispaces/{apiSpaceId}/forms"
                    * @param {string} apiSpaceId - the api space Id
                    */
                    function getForms(apiSpaceId) {

                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/forms")
                            .then(getFormsComplete)
                            .catch(getFormsFailed);

                        function getFormsComplete(response) {
                            return response.data;
                        }

                        function getFormsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{apiSpaceId}/chats/{chatId}/form"
                     * @param {string} apiSpaceId - the api space Id
                     * @param {string} chatId - the chat Id
                     * @param {string} formTemplateId - the form template Id
                     */
                    function sendForm(apiSpaceId, chatId, formTemplateId) {
                        return $http.post(urlBase + "/apispaces/" + apiSpaceId + "/chats/" + chatId + "/form", {
                            formTemplateId: formTemplateId
                        })
                            .then(sendFormComplete)
                            .catch(sendFormFailed);

                        function sendFormComplete(response) {
                            return response.data;
                        }

                        function sendFormFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                }]);
})(window.angular);